<template>
  <div id="page-product-extra-info">
    <commercial-product-extra-info-form
        v-model="model"
        :loading="loading"
        ref="form"
        @add-dynamic-product="addDynamicProduct"
        card-title="Edit"
    />
    <div class="vx-row">
      <div class="vx-col sm:w-1/2">
        <div class="mt-8 flex flex-wrap items-center justify-start">
          <vs-button
              @click="$router.push({ name: 'commercial-products.extra-info.view', params: { id } })"
              class="my-4"
          >
            Cancel
          </vs-button>
        </div>
      </div>
      <div class="vx-col sm:w-1/2">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button
              @click="save"
              class="my-4"
              color="light"
              :disabled="!model.id"
          >
            Save
          </vs-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import CommercialProductExtraInfoForm from "@/views/pages/commercial-products/CommercialProductExtraInfoForm";
import ViewModelMixin from "@/components/mixins/ViewModelMixin";
import NotificationMixin from "@/components/mixins/NotificationMixin";
import SaveModelMixin from '@/components/mixins/SaveModelMixin';

export default {
  name: "CommercialProductExtraInfoEdit",
  components: {
    CommercialProductExtraInfoForm,
  },
  mixins: [ViewModelMixin,NotificationMixin,SaveModelMixin],
  data() {
    return {
      modelEntity: this.$api.commercialProducts,
      entity: 'Commercial Product',
      references: [
        'CommercialProductNode_FK',
      ],
    };
  },
  computed: {
    title() {
      if (!this.model.CommercialProductName) {
        return '';
      }

      const name = this.model.CommercialProductName  || '';
      return '<h1>Commercial Product: ' + name + '</h1>';
    }
  },
  methods: {
    addDynamicProduct(value) {
      this.references.push(value);
    },
    async save() {
      if (!this.$refs.form.validate()) {
        this.notifyError('Not all required fields have been provided');
        return false;
      }

      if (!this.modelEntity) {
        console.warn('No model entity set')
        return;
      }

      const params = await this.getParams();
      delete params.id;

      if (!this.validateParams(params)) {
        return false;
      }
      this.loading = true;

      try {
        const extraInfo = {
          'InsurerDescription': params.InsurerDescription,
          'CoverageDescription': params.CoverageDescription,
          'GuaranteeDescription': params.GuaranteeDescription,
          'InsuredAmountsDescription': params.InsuredAmountsDescription,
          'ExcessDescription': params.ExcessDescription,
          'RetroactivityDescription': params.RetroactivityDescription,
          'ProductImage': params.ProductImage,
          'CommercialProductNode_FK': params.CommercialProductNode_FK,
          'IsOris': params.IsOris,
          'Tag': params.Tag,
        };

        await this.modelEntity.updateExtraInfo(this.id, extraInfo);

        this.notifySuccess(this.entity + ' updated');
      } catch (e) {
        this.notifyError(this.entity + ' failed to be updated');
        console.error(e)
      } finally {
        this.modelCopy = null;
        this.loading = false;
      }

      this.postSave();
    },
  },
};
</script>

<style scoped>

</style>
